import { render } from "./Bancos-App.vue?vue&type=template&id=39bc1598&scoped=true"
import script from "./Bancos-App.vue?vue&type=script&lang=js"
export * from "./Bancos-App.vue?vue&type=script&lang=js"

import "./Bancos-App.vue?vue&type=style&index=0&id=39bc1598&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39bc1598"]])

export default __exports__